import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KioskStateService } from '../../services/kiosk-state.service';
import { KioskStateEnum } from '../../services/kiosk-state.enum';

@Component({
  selector: 'app-kiosk-thank-you',
  templateUrl: './kiosk-thank-you.component.html',
  styleUrls: ['./kiosk-thank-you.component.css']
})
export class KioskThankYouComponent implements OnInit {

  constructor(
    private kioskStateService: KioskStateService
  ) { }

  ngOnInit() {
    setTimeout(
      () => {
        this.kioskStateService.update(KioskStateEnum.Reset);
      },
      5000);
  }

}
